// extracted by mini-css-extract-plugin
module.exports = {"noProjects":"NoPublicProjects_noProjects__OtDq-","noProjectsIcon":"NoPublicProjects_noProjectsIcon__YGfL0","noProjectsText":"NoPublicProjects_noProjectsText__3JVfS"};